import "./SkeletonPage.scss";

import { FC } from "react";
import Skeleton from "react-loading-skeleton";

import SkeletonContent from "./SkeletonContent";

const SkeletonPage: FC = () => {
  return (
    <div className="link-list">
      <div className="link-list__item">
        <Skeleton height={56} borderRadius={12} />
      </div>
      <div className="link-list__wrapper">
        <div className="link-list__header">
          <ul className="link-list-heading">
            <li className="long-url-column table-header">
              <Skeleton height={32} />
            </li>
            <li className="owner-column table-header">
              <Skeleton height={32} />
            </li>
            <div className="date-added-column table-header">
              <Skeleton height={32} />
            </div>
            <li className="views-column table-header">
              <Skeleton height={32} />
            </li>
            <li className="short-link-column table-header">
              <Skeleton height={32} />
            </li>
          </ul>
        </div>
        <SkeletonContent />
      </div>
    </div>
  );
};

export default SkeletonPage;
